/**
 * Link target enum
 *
 * @package lib-components
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export enum LINK_TARGET {
	SELF = "_self",
	BLANK = "_blank",
	TOP = "_top"
}

export type LINK_TARGET_string = keyof typeof LINK_TARGET;

export const LINK_TARGET_default = "SELF";
